export default {
  set(state, { data }) {
    state.machines = data;
  },
  show(state, { data }) {
    state.machine = data;
  }
}